module.exports = __webpack_public_path__ + "static/media/food1.a2f9be71.jpeg";